/* Tabs for the Unpair Strand Grid: one tab per side, the matching list of strands underneath.
   The first list is shown by the page itself and the others carry the `hidden` attribute, so nothing flashes before this script runs.
   (There is deliberately no <noscript> fallback: the theme editor re-renders a section from parsed HTML, which turns a <noscript> style into a live rule and hid the tabs.) */
class UnpairStrandTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    if (!this.tabs.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.select(tab));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
    });
  }

  select(tab, focus = false) {
    this.tabs.forEach((other) => {
      const selected = other === tab;
      other.setAttribute('aria-selected', String(selected));
      other.tabIndex = selected ? 0 : -1;

      const panel = document.getElementById(other.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });

    if (focus) tab.focus();
  }

  // Left and Right arrows move between the tabs (wrapping around), Home and End jump to the first and last
  onKeydown(event, tab) {
    const index = this.tabs.indexOf(tab);
    let next;

    switch (event.key) {
      case 'ArrowRight':
        next = this.tabs[(index + 1) % this.tabs.length];
        break;
      case 'ArrowLeft':
        next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
        break;
      case 'Home':
        next = this.tabs[0];
        break;
      case 'End':
        next = this.tabs[this.tabs.length - 1];
        break;
    }

    if (next) {
      event.preventDefault();
      this.select(next, true);
    }
  }
}

if (!customElements.get('unpair-strand-tabs')) {
  customElements.define('unpair-strand-tabs', UnpairStrandTabs);
}
